module.exports = __webpack_public_path__ + "img/pfondo.f647f767.png";